import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// depreciation_schedules — ตารางค่าเสื่อมราคา (Depreciation Schedule)
// ============================================================================
export const depreciationSchedules = sqliteTable("accounting_depreciation_schedules", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  assetId: text("asset_id").notNull(),
  scheduleDate: text("schedule_date").notNull(),  // YYYY-MM-DD
  depreciationAmount: real("depreciation_amount").notNull().default(0),
  accumulatedDepreciation: real("accumulated_depreciation").notNull().default(0),
  netBookValue: real("net_book_value").notNull().default(0),
  isBooked: integer("is_booked").notNull().default(0),  // 1 = GL entry created
  journalEntryId: text("journal_entry_id"),  // link to journal entry when booked
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  ds_asset_idx: index("ds_asset_idx").on(table.assetId, table.scheduleDate),
  ds_company_date_idx: index("ds_company_date_idx").on(table.companyId, table.scheduleDate),
}));

export type DepreciationSchedule = typeof depreciationSchedules.$inferSelect;
export type NewDepreciationSchedule = typeof depreciationSchedules.$inferInsert;
